import { matchPath, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../utils/authorization';
import { SpinnerCircularFixed } from '../../assets/spinner/SpinnerCircularFixed';

type ProtectedRouteProps = {
    requiredScopes?: string[];
    any?: boolean;
};

export default function ProtectedRoute({ requiredScopes = [], any = false }: ProtectedRouteProps) {
    const { user, loading } = useAuth();
    const location = useLocation();
    const pathname = location.pathname;

    if (loading) {
        return (
            <div className="sync-widget-loading">
                <div className="spinner" style={{ height: '100vh' }}>
                    <SpinnerCircularFixed />
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    const idStore = user.stores?.[0]?.toString() ?? '';

    if (user.stores?.length === 1 && Number(idStore) !== 0) {
        const targetPath = `/management/${idStore}`;
        const isGeneralRoute =
            pathname === '/' || ['/stores', '/create'].some((p) => pathname.startsWith(p));
        const managementMatch =
            matchPath({ path: '/management/:id/*' }, pathname) ||
            matchPath({ path: '/management/:id' }, pathname);

        const urlId = managementMatch?.params?.id?.toString() ?? '';
        const isIncorrectManagementRoute = managementMatch && urlId && urlId !== idStore;
        if (isGeneralRoute || isIncorrectManagementRoute) {
            return <Navigate to={targetPath} replace />;
        }
    }

    if (requiredScopes.length > 0) {
        const userScopes = user.scopes ?? [];
        const hasWildcard = userScopes.includes('*');
        const ok = hasWildcard
            ? true
            : any
                ? requiredScopes.some((scope) => userScopes.includes(scope))
                : requiredScopes.every((scope) => userScopes.includes(scope));

        if (!ok) {
            return <Navigate to="/unauthorized" replace />;
        }
    }

    return <Outlet />;
}
